import type { FaireProductEntity } from "../../entity_types/product";

export const p_4cuu7fzzz3: FaireProductEntity = {
  token: "p_4cuu7fzzz3",
  type: "product",
  name: 'Set of 2 Extra Large Rough Texture Planters-Grey-9+13"D',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/8f58d837588bd68a0ff99667a855f40f46f074b93f956fa05227d9b7c8faf51a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7710df03b6b043e76747d207bab86623da4f7e14de390128a4c57c3085675c9f.jpeg",
    "https://cdn.faire.com/fastly/a47fc20f51b909e92fd8bfa9a159c1fa094ef02569ffed2300f315a4e6fef8ec.jpeg",
  ],
  priceDollars: 85,
  description:
    "This set of extra-large Rough Textured Planters are crafted from a durable cement and fiberglass blend and feature a textured exterior that adds a modern, tactile element to any space. The nested design allows for easy storage and versatile use, making them perfect for both indoor and outdoor settings, blending style with practicality.",
  tags: [],
  msrpDollars: 170,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:13.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
